// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3ZzkU","content":"Consent_content__2NNre","footer":"Consent_footer__1Sb59"};